// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2019-01-25T10:28:39Z                      #

// ##############################################################

import ErrorApi from "./../../../utils/ErrorApi";
import Fetch from "./../../../utils/Fetch";
import ParamsFetch from "./../../../utils/ParamsFetch";
import JsonFetch from "./../../../utils/JsonFetch";
import generateUrl from './../../../utils/generateUrl';

import * as UpdateMethods from "./UpdateMethods";

/**
 * Rozhraní pro práci s právními formami. Generated from cz.marbes.api.subjekt.PravniFormaService.
 */
export default class PravniFormaApi {
    /**
     * Načtení právní formy dle id.
     *
     * @param id id právní formy
     * @return načtená právní forma
     */
    static getPravniFormaById(id : number) : Promise<PravniForma> {
        const uri = serverContextPath + `/api/subjekty/pravniFormy/${id}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Načtení seznamu právních forem.
     *
     * @param typPravniFormy pokud je uvedeno, vrací se právní formy jen pro daný typ, jinak se vrací pro všechny typy
     * @param pridatNeaktivni mají se přidat i neaktivní prání formy?
     * @return seznam právních forem nebo prázdný seznam
     */
    static getPravniFormy(typPravniFormy : TypPravniFormy, pridatNeaktivni : boolean) : Promise<PravniForma[]> {
        const uri = serverContextPath + `/api/subjekty/pravniFormy`;
        const headers = undefined;
        const params = { typPravniFormy, pridatNeaktivni };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Dohledání právních forem dle seznamu předaných id.
     *
     * @param ids seznam id právních forem
     * @return seznam dohledaných právních forem, pokud bude předáno id neexistující právní formy, bude ignorováno
     */
    static findPravniFormyByIds(ids : number[]) : Promise<PravniForma[]> {
        const uri = serverContextPath + `/api/subjekty/pravniFormy/byIds`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, ids, headers));
    }

}